<template>
    <div class="flex flex-center-sp">
        <div class="help-body flex flex-col">
            <div class="margin-top-xxl flex flex-center-sp font-xxl font-bold">帮助中心</div>
            <div class="flex margin-top-xxl">
                <div class="help-card flex flex-col margin-right-xl">
                    <div class="font-bold font-xl bottom-line lh45">新手引导</div>
                    <div class="lh35 margin-top-m flex flex-center-cz pointer" @click="showDoc('doc?shareId=1883492319260389377')"><img class="logo-15 margin-right-s" src="@/assets/images/qianjin.png"/><span>认识量子文档</span></div>
                    <div class="lh35 flex flex-center-cz pointer" @click="showDoc('doc?shareId=1883500462086369282')"><img class="logo-15 margin-right-s" src="@/assets/images/qianjin.png"/><span>如何使用便签</span></div>
                    <div class="lh35 flex flex-center-cz pointer" @click="showDoc('doc?shareId=1883500028907040769')"><img class="logo-15 margin-right-s" src="@/assets/images/qianjin.png"/><span>如何写日记</span></div>
                    <div class="lh35 flex flex-center-cz pointer" @click="showDoc('doc?shareId=1883500186470264833')"><img class="logo-15 margin-right-s" src="@/assets/images/qianjin.png"/><span>如何记待办</span></div>
                </div>
                <div class="help-card flex flex-col margin-left-xl">
                    <div class="font-bold font-xl bottom-line lh45">联系我们</div>
                    <div class="lh35 margin-top-m flex flex-center-cz pointer" @click="showDoc('doc?id=1883505966128902145')"><img class="logo-15 margin-right-s" src="@/assets/images/qianjin.png"/><span>问题反馈</span></div>
                    <div class="lh35 flex flex-center-cz pointer" @click="contact()"><img class="logo-15 margin-right-s" src="@/assets/images/qianjin.png"/><span>联系官方</span></div>
                    <div v-if="false" class="lh35 flex flex-center-cz pointer"><img class="logo-15 margin-right-s" src="@/assets/images/qianjin.png"/><span>开发票</span></div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
 export default {
    name:'Help',
    methods:{
      showDoc(url) {
        this.$router.push({
            path: '/' + url,
        }) 
      },
      contact() {
        this.$router.push({
            path: '/contact' 
        })
      }

    }

 }
    

</script>

<style scoped>
  .help-body {
    margin-top: 60px;
    width: 800px;
    min-height: 500px;
  }
  .help-card {
    width: 380px;

  }







</style>


// WEBPACK FOOTER //
// src/views/Help.vue